import { rowsType } from '.'

export const mountRunInfo = (
    run: Run,
    wellIndex: number
): {
    wellIndex: number
    type: RowType
    name: string
    begin: string
    end: string
} => {
    const runInfo = {
        wellIndex: wellIndex,
        type: rowsType[2],
        name: run?.name || run?.type || 'RUN',
        begin: run?.start?.toString(),
        end: run?.end?.toString() ?? new Date().getTime()
    }

    return runInfo
}
